import {
  Modal,
  DragAndDropFileUploader,
  Button,
  useTranslation,
  formatBytes,
} from '@testsigma/atoms';
import { useContext, useEffect, useState } from 'react';
import { WindowsAdvancedElementsContext } from '../../list/windows-advanced-elements-context';

export const WindowsAdvancedElementImportPopup = () => {
  const { t } = useTranslation();
  const {
    currentElementFile,
    updateCurrentPopup,
    handleUpload,
    isUploading,
    currentPopup,
  } = useContext(WindowsAdvancedElementsContext);

  const [typeErrorMessage, setTypeError] = useState<string>();
  const [sizeErrorMessage, setSizeError] = useState<string>();
  const [dataFile, setDataFile] = useState<File>();

  useEffect(() => {
    const timeout = setTimeout(() => {
      if (window.location.hash == '#importElements') window.location.hash = '';
    }, 100);
    return () => clearTimeout(timeout);
  });

  return (
    <Modal isOpen={true} className='min-w-[480px] max-w-[480px] !rounded-xl'>
      <div className='text-lg font-medium text-unique-600 mb-6'>
        {t(currentElementFile ? 'uft.element.update' : 'uft.element.import')}
      </div>

      {currentElementFile && (
        <div className='mb-6 flex'>
          <div className='flex-grow flex-shrink-0 flex flex-col gap-1'>
            <div className='text-xs text-secondary-600'>
              {t('uft.current.file')}
            </div>
            <div className='text-xs font-medium text-primary-900'>
              {currentElementFile.file}
            </div>
          </div>

          <div className='flex-grow flex-shrink-0 flex flex-col gap-1'>
            <div className='text-xs text-secondary-600'>
              {t('common.lastupdate')}
            </div>
            <div className='text-xs font-medium text-primary-900'>
              {currentElementFile.updatedOn}
            </div>
          </div>
        </div>
      )}

      <DragAndDropFileUploader
        className='w-72'
        onTypeError={setTypeError}
        onSizeError={setSizeError}
        handleChange={setDataFile}
        maxSize={300}
        accept={['tsrx']}
        acceptedExtensions={['tsrx']}>
        {typeErrorMessage || sizeErrorMessage ? (
          <div className='text-2xs leading-4 font-normal text-error-500'>
            {typeErrorMessage
              ? t('uft.element.import.notsupported')
              : sizeErrorMessage}
          </div>
        ) : dataFile ? (
          <div className='flex flex-col gap-3 mt-3 text-unique-800 text-small'>
            {t('import.uft.selected.size')} {formatBytes(dataFile.size)}
          </div>
        ) : (
          <div className='flex flex-col gap-3 mt-3 text-unique-800'>
            <span className='text-small'>{t('import.uft.files')}</span>
            <span className='text-small'>{t('import.uft.maxsize')}</span>
          </div>
        )}
      </DragAndDropFileUploader>

      <div className='mt-6 flex justify-end gap-3'>
        <Button
          type='secondary'
          onClick={() => updateCurrentPopup({ popup: null })}
          isDisabled={isUploading}>
          {t('common.cancel')}
        </Button>
        <Button
          className='w-20'
          isDisabled={!dataFile || isUploading}
          onClick={() => handleUpload(dataFile, currentPopup?.version?.id)}
        >
          {!isUploading &&
            t(!currentElementFile ? 'common.import' : 'common.update')}
          {isUploading && (
            <div className='empty-page-loader !h-4 !w-4 !max-h-4 !max-w-4 !min-h-4 !min-w-4 !border-[2px] !border-t-transparent m-auto' />
          )}
        </Button>
      </div>
    </Modal>
  );
};
